import {observable} from 'mobx';
import {DomainObject} from 'shared/store';

class CandidateTag extends DomainObject {
  @observable id;
  @observable name;
}

export default CandidateTag;
